import React from 'react';
import Card from '../../../components/ACS-Dashboard/ACS-Blocks/Card';
import ScrollableContainer from '../../../components/ACS-Dashboard/ACS-Blocks/ScrollableContainer';


const InventoryList = ({ }) => {
  // Sample data for the scrollable cards
  const cardsData = [
    { title: "New Alerts", percentage: "+10%", comparisonText: "vs last week", mainValue: "25" },
    { title: "Unread Messages", percentage: "-5%", percentageColor: "text-red-500", comparisonText: "vs yesterday", mainValue: "8" },
    { title: "Total Messages", percentage: "+3%", comparisonText: "vs last month", mainValue: "120" },
    { title: "Total Messages", percentage: "+3%", comparisonText: "vs last month", mainValue: "120" },
    { title: "Total Messages", percentage: "+3%", comparisonText: "vs last month", mainValue: "120" },
    { title: "Total Messages", percentage: "+3%", comparisonText: "vs last month", mainValue: "120" },
    { title: "Total Messages", percentage: "+3%", comparisonText: "vs last month", mainValue: "120" },
    { title: "Total Messages", percentage: "+3%", comparisonText: "vs last month", mainValue: "120" },
  ];

  return (
    <div className="p-fluid-1 bg-color-custom-bg-purple">
      <ScrollableContainer direction="x" className="scrollbar-none">
        <div className="flex gap-[clamp(0.5rem,1cqw,1rem)]"> {/* Container-queried gap */}
          {cardsData.map((card, index) => (
            <div 
              key={index} 
              className="scroll-snap-align-start"
              style={{ 
                minWidth: 'clamp(12rem,30cqw,11rem)',  // 30% of container width
                flex: '0 0 auto'  // Prevent flex growing
              }}
            >
              <Card 
                {...card}
                className="p-fluid-1.5"
                titleClassName="text-fluid-lg"
                valueClassName="text-fluid-xl"
                metaClassName="text-fluid-sm"
              />
            </div>
          ))}
        </div>
      </ScrollableContainer>
    </div>
  );
};

export default InventoryList;
